import { device } from '../../../constants/StyledComponentConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import UsageTracker from '../../../utils/UsageTracker';
import ResponsiveCardGridContainer from '../../../components/ResponsiveCardGridContainer';
import { PageSectionHeading } from '../../../components/SectionHeading';
import { RouterLink } from '../../../components/AcademyLinks';
import styled, { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { NavMarker } from 'react-rhumb';
import { useMyLearningCardModels } from '../../myLearning/myLearningQueries';
import { MyLearningTabTypeToRequestMapping } from '../../myLearning/myLearningConsts';
import LearningContentCard from '../../cards/components/LearningContentCard';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getMyLearningUrl } from '../../myLearning/myLearningRouting';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { useUserProgressState } from '../userProgressStore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE = 3;
const CardBox = styled.div.withConfig({
  displayName: "InProgressSection__CardBox"
})(["width:100%;&:not(:last-child){@media screen and ", "{margin-right:32px;flex-basis:auto;}}"], device.mobile);
const useInProgressSection = () => {
  const {
    myLearningCardModels: inProgressItems,
    myLearningCardModelsLoading: inProgressItemsLoading,
    myLearningCardModelsError: inProgressItemsError,
    totalCount
  } = useMyLearningCardModels({
    contentTypes: MyLearningTabTypeToRequestMapping['all'],
    offset: {
      cursor: 0
    },
    pageLength: PAGE_SIZE,
    progressType: 'IN_PROGRESS',
    includePlaylistProgress: true
  });
  const {
    simulateNoProgress
  } = useUserProgressState();
  return {
    inProgressItems: simulateNoProgress ? [] : inProgressItems,
    inProgressItemsLoading,
    inProgressItemsError,
    totalCount
  };
};
const ViewAllLink = () => {
  const {
    isMobile
  } = useMediaQuery();
  const trackViewAllClick = () => UsageTracker.track('interaction', {
    action: 'in-progress-view-all-clicked'
  });
  return /*#__PURE__*/_jsx(RouterLink, {
    onClick: trackViewAllClick,
    to: getMyLearningUrl(),
    underline: true,
    children: isMobile ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.inProgressSection.seeAll"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.inProgressSection.viewAll"
    })
  });
};
export const InProgressSection = () => {
  const {
    inProgressItems,
    inProgressItemsError,
    inProgressItemsLoading,
    totalCount
  } = useInProgressSection();
  const {
    isMobile,
    isLaptop
  } = useMediaQuery();
  if (inProgressItemsLoading || inProgressItemsError || !(inProgressItems !== null && inProgressItems !== void 0 && inProgressItems.length)) return null;
  const showViewMoreLink = totalCount > PAGE_SIZE;
  return /*#__PURE__*/_jsxs(HomePageSection, {
    paddingBlock: "0",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_INPROGRESS_LOADED"
    }), /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      marginBlockEnd: isMobile ? '200' : '400',
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 2,
        children: /*#__PURE__*/_jsx(PageSectionHeading, {
          marginBlockEnd: "0",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.inProgressSection.sectionTitle"
          })
        })
      }), showViewMoreLink && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(ViewAllLink, {})
      })]
    }), /*#__PURE__*/_jsx(ResponsiveCardGridContainer, {
      className: "noBorder noPadding",
      columnSize: 250,
      columns: isLaptop ? 1 : 3,
      gutterSize: isMobile ? 8 : 20,
      nowrap: false,
      paddingBlockEnd: "0",
      scrollOnMobile: false,
      children: inProgressItems.map(item => /*#__PURE__*/_jsx(CardBox, {
        children: /*#__PURE__*/_jsx(LearningContentCard, {
          item: item,
          overviewType: "my-learning",
          size: "small"
        })
      }, `item_progress_${item.id}`))
    })]
  });
};
export default InProgressSection;